import type {
  FloorContentTeaserProductDTO,
  FloorDepartmentDTO,
  FloorPlanDisplayGutterStyle,
} from '~gateways/ownable.dtos';
import type { JourneyParameters } from '~types/navigation';

export type FloorLayout = 'BrandConcession' | 'ProductSet';

export type FloorDM = {
  id: number;
  floorNumber: number;
  title: string;
  layout: FloorLayout;
  isDefault: boolean;
  width: number;
  height: number;
  departments: FloorDepartmentDTO[];
};

export type FloorContentDM = {
  floorId: number;
  floorName: string;
  layout: FloorLayout;
  width: number;
  height: number;
  cells: FloorContentCellDM[];
  pathwaysHorizontal: number[];
  pathwaysVertical: number[];
};

export type FloorContentCellDM = {
  departmentId: number;
  isFocusPoint: boolean;
  x: number;
  y: number;
  displayId: number;
  heroImageUrl: string;
  displayTitle: string;
  displaySubTitle: string;
  destination: JourneyParameters;
  displayGutterStyle: FloorPlanDisplayGutterStyle;
  products: FloorContentTeaserProductDm[];
};

type FloorContentTeaserProductDm = FloorContentTeaserProductDTO;

type Params = Partial<Pick<JourneyParameters, 'journey' | 'journeyParam'>>;

export const getFloorSpecFromJourney = ({
  journey,
  journeyParam,
}: Params): FloorDM['id'] | undefined => {
  if (!journey || !journeyParam) {
    return undefined;
  }

  if (journey !== 'floor') {
    return undefined;
  }

  return Number(journeyParam)!;
};
